<template>
    <vue-modal :open="open">
        <div class="bax-modal-content bax-modal-icon-content text-center">
            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                <i class="icon-upload"></i>
            </div>
            <h2>Submit for review</h2>
            <p>Your custom PN formulation will now be sent to our Compounding Team for review and may be subject to change.</p>
            <p>You will be notified of the formulation profile.If you have any queries, please contact our Team to discuss.</p>
            <p>Would you like to submit your formulation for review?</p>

            <p class="disclaimer">The Parenteral Nutrition Compatibility Tool (“PN Tool”) is a tool to assist a healthcare professional (“HCP”) to develop a parenteral nutrition solution based on the chemical stability data for the proposed composition. The PN Tool will generate an estimate of chemical stability based on the composition entered by the HCP. The HCP must exercise independent judgement when examining the results generated by the PN Tool. The PN Tool is not intended to provide advice of any nature, and it is not a guarantee of chemical stability. The proposed solution is submitted via the PN Tool to Baxter Compounding Operations Team for review, however the final PN solution will be subject to the HCP’s approval. The HCP-approved solution is then sent for manufacture by Baxter Compounding facilities.</p>
            <p class="disclaimer">The PN Tool is intended for use in Australia and New Zealand only, and is subject to updates. For the most current stability data, please contact your local compounding site. Please note that clinical discretion should be used before the administering any Baxter parenteral nutrition solutions.</p>
            <div class="bax-modal-action-items">
                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="closeModal">Cancel</button>
                <button type="button" class="bax-btn bax-btn-blue-brand" :class="{ 'loading': submitting }" @click.prevent="onSave()">Submit</button>
            </div>
            <div class="feedback" v-if="feedback">
                {{feedback}}
            </div>
        </div>
    </vue-modal>
</template>
<script>

import CustomFormulationService from '@/core/api/tpn/customFormulation.service';

export default {
    name: 'SubmitReviewModal',
    props: {
        open: {
            required: true,
        },
        formData: {
            required: true,
        },
        savedId: {
            required: true,
        },
    },
    data() {
        return {
            submitting: false,
            feedback: '',
        };
    },
    methods: {
        closeModal() {
            if (!this.submitting) {
                this.$emit('modal_submit_review_close');
            }
        },
        onSave() {
            if (!this.submitting) {
                this.submitting = true;
                this.feedback = false;
                const payload = {
                    type: 'submitReview',
                    formData: this.formData,
                    formulationRecordId: this.savedId,
                    contentTable: document.getElementById('recap-table').outerHTML,
                };
                CustomFormulationService.handleCustomFormulation(payload)
                .then((res) => {
                    this.submitting = false;
                    if (res.data.error) {
                        this.feedback = 'Sorry, something went wrong';
                    } else {
                        this.$emit('modal_submit_review_submit');
                    }
                });
            }
        },
    },
};
</script>

<style>
  p.disclaimer {
    font-size: 16px;
    line-height: 20px;
    font-style: italic;
  }
</style>
